import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminService } from '../../services/admin.service';
import type { UserVoiceDto } from '../../models/admin-dto';

@Component({
  selector: 'app-user-voice',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './user-voice.component.html',
  styleUrl: './user-voice.component.css'
})
export class UserVoiceComponent implements OnInit {
  title = '';
  content = '';
  submitting = false;
  submitError: string | null = null;
  submitSuccess = false;
  ideas: UserVoiceDto[] = [];
  loading = true;

  constructor(
    private readonly admin: AdminService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadIdeas();
  }

  loadIdeas(): void {
    this.loading = true;
    this.cdr.markForCheck();
    this.admin.getUserVoiceList().subscribe({
      next: (list) => {
        this.ideas = list ?? [];
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  submit(): void {
    this.submitError = null;
    this.submitSuccess = false;
    if (!this.title?.trim()) {
      this.submitError = 'Title is required.';
      this.cdr.markForCheck();
      return;
    }
    this.submitting = true;
    this.cdr.markForCheck();
    this.admin.submitUserVoice({ title: this.title.trim(), content: this.content?.trim() ?? '' }).subscribe({
      next: () => {
        this.submitSuccess = true;
        this.title = '';
        this.content = '';
        this.submitting = false;
        this.loadIdeas();
        this.cdr.markForCheck();
      },
      error: (err: Error) => {
        this.submitError = err?.message ?? 'Failed to submit.';
        this.submitting = false;
        this.cdr.markForCheck();
      }
    });
  }
}
